<!-- <script setup>
import HeadingWithPara from '@/components/HomeCompoent/HeadingWithPara.vue';
import cardImage1 from '@/assets/images/digitalLanyard.png';
import cardImage2 from '@/assets/images/idddcardd.png';
import cardImage3 from '@/assets/images/accessories.png';
import cardImage4 from '@/assets/images/DigitalBelt.png';
import cardImage5 from '@/assets/images/membership.png';
import cardImage6 from '@/assets/images/photoshot.png';
import cardImage7 from '@/assets/images/attendance.png';
import cardImage8 from '@/assets/images/cardsystem.png';
import cardImage9 from '@/assets/images/software.png';

const services = [
  { id: 1, name: " DIGITAL LANYARD", color: "#C0EAFF", image: cardImage1 ,slug: "digital-lanyard"},
  { id: 2, name: " ID CARD", color: "#FFCB66", image: cardImage2  ,slug: "id-card"},
  { id: 3, name: " ACCESSORIES", color: "#CBCC65", image: cardImage3  ,slug: "accessories"},
  { id: 4, name: " DIGITAL BELT", color: "#DFD0FF", image: cardImage4   ,slug: "digital-belt"},
  { id: 5, name: " LOYALTY/MEMBERSHIP CARD", color: "#BBEDFA", image: cardImage5  ,slug: "loyalty-card"},
  { id: 6, name: "PHOTO SHOOT", color: "#CCFFD3", image: cardImage6   ,slug: "photo-shoot"},
  { id: 7, name: "ATTENDANCE SYSTEM", color: "#E8F8AA", image: cardImage7   ,slug: "attendance-system"},
  { id: 8, name: " ID CARD SYSTEM", color: "#EDDDB1", image: cardImage8   ,slug: "id-card-system"},
  { id: 9, name: " SCHOOL SOFTWARE", color: "#E1B5D6", image: cardImage9    ,slug: "school-software"},
]
</script> -->

<template>
  <section class="section-spacing">
    <v-container>
      <HeadingWithPara :title="'OUR SERVICE'" :paragraph="'WE WORK ON A MOST EASY AND SMART WAY,'"
        :subText="'IN JUST 4 STEP YOU CAN EASYLY GET YOUR ORDER AT YOUR PLACE.'" />
      <v-row dense>
        <v-col v-for="(item, index) in serviceCards" :key="index" cols="12" sm="4">
          <RouterLink :to="{ name: 'serviceProduct', params: { id: item.id } }" class="text-decoration-none">
            <v-card class="text-center pa-4" outlined :style="{ backgroundColor: getCardColor(index) }">
              <!-- <v-card class="text-center pa-4" outlined :style="{ backgroundColor: card.color }"> -->
              <v-row>
                <v-col cols="8" class="d-flex flex-column justify-center">
                  <v-card-title class="text-h6 text-wrap title" :style="{ wordBreak: 'break-word' }">
                    {{ item.title }}
                  </v-card-title>
                </v-col>
                <v-col cols="4" class="d-flex align-center justify-center">

                  <v-img :src="item.image
                    " class="mb-2 image" max-height="100"></v-img>


                </v-col>
              </v-row>

            </v-card>
          </RouterLink>
        </v-col>
        <!-- <v-col v-for="(item, index) in serviceCards" :key="index" class="scroll-item mb-7" cols="12" sm="6" md="4">
        <RouterLink :to="{ name: 'serviceProduct', params: { id: item.id } }" class="text-decoration-none">

        <v-card class="modern-card position-relative">
          <v-img transition="slide-x-transition" :src="item.image
              ? 'http://192.168.1.83:8002' + item.image
              : '/src/assets/images/administrator.jpg'
            " height="300px" contain class="image"></v-img>
          <div class="card-box">
            <h3 class="mb-0 text-center">{{ item.title }}</h3>
          </div>
        </v-card>

        </RouterLink>
      </v-col> -->
      </v-row>
    </v-container>
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref, onMounted } from "vue";
import { serviceCard } from '@/services/apiServices.js'
import HeadingWithPara from '@/components/HomeCompoent/HeadingWithPara.vue';
import { apiConfig } from "@/config/apiConfig";
import banner1 from "@/assets/images/administrator.jpg";

const error = ref("");
const serviceCards = ref("");

const colors = [
  "#C0EAFF", // DIGITAL LANYARD
  "#FFCB66", // ID CARD
  "#CBCC65", // ACCESSORIES
  "#DFD0FF", // DIGITAL BELT
  "#BBEDFA", // LOYALTY/MEMBERSHIP CARD
  "#CCFFD3", // PHOTO SHOOT
  "#E8F8AA", // ATTENDANCE SYSTEM
  "#EDDDB1", // ID CARD SYSTEM
  "#E1B5D6", // SCHOOL SOFTWARE
];
// Helper function to safely get color
const getCardColor = (index) => colors[index % colors.length];

const getImage = (item) => {
  // console.log("item", item);
  // console.log("apiConfig.ImageUrl", apiConfig.imageUrl);
  return item ? `${apiConfig.imageUrl}${item}` : banner1;
};

// import { getCurrentInstance } from 'vue';
// const { appContext } = getCurrentInstance();
// const getImage = appContext.config.globalProperties.$getImage;

const fetchServicesCard = async () => {
  try {
    const data = await serviceCard();
    serviceCards.value = data;
  } catch (err) {
    error.value = err.response?.data?.message || "Failed to load classes";
    console.error("Error fetching class details:", err);
  }
};

const router = useRouter();


onMounted(fetchServicesCard);

</script>

<style>
.v-card {
  border-radius: 12px;
}

.text-wrap {
  white-space: normal;
  /* Allow text to wrap */
  overflow-wrap: break-word;
  /* Break long words if necessary */
  word-wrap: break-word;
  /* Support for older browsers */
}

.image {
  width: 100px;
  height: 100px;
  object-fit: contain;
}
</style>
